import { useApi } from './useApi';

export function useManifest() {
  const { fetchData, postData, putData, data, error, loading } = useApi();
  const fetchManifestApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/manifests', { params });

      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message || 'Lỗi kết nối'
      };
    }
  };

  const deleteManifestApi = async (id) => {
    try {
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const getManifestDetailApi = async (id) => {
      try {
          const result = await fetchData(`/api/manifests/${id}?include=items,customer&searchJoin=AND`);
          return {
              success: true,
              data: result
          };
      } catch (err) {
          return {
              success: false,
              error: err.message || 'Lỗi kết nối'
          };
      }
  };

  const createManifestApi = async (credentials) => {
    try {
      const result = await postData('/api/manifests', credentials);
      return {
        success: true,
        data: result
      };
    } catch (err) {
      return {
        success: false,
        error: err.message
      };
    }
  };

    const updateManifestApi = async (id, credentials) => {
        try {
            const result = await putData(`/api/manifests/${id}`, credentials);

            return {
                success: true,
                data: result
            };
        } catch (err) {
            return {
                success: false,
                error: err.message || 'Lỗi kết nối'
            };
        }
    };

  return { fetchManifestApi, deleteManifestApi, createManifestApi, getManifestDetailApi, updateManifestApi };
}
